import { ToastProvider } from "@/components/ui/ToastProvider";

import { DesignSystemComponentsClient } from "./DesignSystemComponentsClient";

export default function ComponentsPage() {
  return (
    <ToastProvider>
      <DesignSystemComponentsClient />
    </ToastProvider>
  );
}
